<div class="flex justify-content-center wrapper bg-search">
  <div class="wrapper-content lg:gap-2 xl:gap-4 xl:mx-0 sm:mx-3">
    <section class="content-main f-70">
      <h1 class="title-section title-blue my-2 text-uppercase ml-0" >{{'components.app-consulta-tramites.consulta-de-trámites'| translate}}</h1>
      <span class="block text-base app-text-gray my-2 ml-0">{{'components.app-consulta-tramites.subtitle-consulta-de-trámites'| translate}}:</span>
      <section class="search-bar ">
        <div class="container-input border-none sm:border-3 border-gradient">
          <div class="input-text border-gradient sm:border-none border-3 ">
            <img class="icon" draggable="false" alt="icon search" src="assets/img/icons-principal/ico-search.svg">
            <input type="text" class="border-none font-18" pInputText [(ngModel)]="text" [style]="{'width':'100%'}" (keydown.enter)="buscar()"
                   [placeholder]="'components.app-consulta-tramites.placeholder'| translate"/>
          </div>

          <p-multiSelect [options]="dependencias" optionLabel="descripcion"  class="mr-0 md:mr-2 lg:w-3 w-full sm:w-5 sm:max-w-12rem"
                      [placeholder]="'components.app-consulta-tramites.dependencias' | translate" [maxSelectedLabels]="2"
                      [(ngModel)]="dependenciasSelected"
                      [filter]="true"></p-multiSelect>
          <div class="sm:hidden block ">
            <div class="text-exmaple">
              <p class="mt-0">Por ejemplo: Acá se listarían los trámites más frecuentes a manera de vinculos. </p>
            </div>
          </div>
          <button pButton type="submit"
               class="search btn-blue-general font-light md:px-3 flex md:justify-content-between md:w-8rem"   (click)="buscar()">
            <span class="ml-0 font-normal" style="margin-right:3px">{{'form.button.buscar' | translate}}</span>
            <svg-loader name="ico-normal-tramitfly-white" />
          </button>
        </div>
        <div class="hidden md:block">
          <div class="field col-12 flex  flex-column align-items-center">
            <div class="flex align-self-stretch justify-content-around flex-wrap">
              <div class="text-exmaple">
                <p class="mt-0">Por ejemplo: Acá se listarían los trámites más frecuentes a manera de vinculos. </p>
              </div>
              <div>
                <a class="text-blue-general underline" [routerLink]="['/public/resultados/all']">Ver lista completa de
                  Trámites. </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <article class="content-secondary f-30 hidden lg:flex ">
      <div class="">
        <h1 class="font-22 font-normal  font-roboto-condensed title-blue my-2  ml-0 pl-0 text-uppercase" >{{'components.app-consulta-tramites.ver-estado-tramites' | translate}}</h1>
        <span class="block text-base font-normal app-text-gray my-2">{{'components.app-consulta-tramites.subtitle-estado-tramites' | translate}}:</span>
      </div>

      <div class=" container-input-rounded border-outline-blue-light bg-white  ">
        <div class="input-text flex align-items-center">
          <div class="border-circle container-icon ">
            <span class="title-blue">#</span>
          </div>
          <input type="text" pInputText [(ngModel)]="radicado" [style]="{'width':'100%'}"
                 (keydown.enter)="buscarRadicado()" class="input-text-gray"
                 [placeholder]="'components.app-consulta-tramites.placeholder-radicado'| translate"/>
        </div>

        <button pButton class="bg-blue-light"  (click)="buscarRadicado()" >
          <span class="title-blue">{{'form.button.ver' | translate}}</span>
          <svg-loader name="ico-normal-tramitfly-white" [containerClass]="'blue-dark'" />
        </button>
      </div>


    </article>
  </div>
</div>
<div class="wrapper-content md:mt-0 mt-4 xl:mx-auto sm:mx-3 sm:w-auto flex-column
 lg:flex-row lg:w-full xl:gap-4 lg:gap-2">
  <app-resultados-busqueda  typeContent="card" class="f-70"/>

  <div class="f-30 mb-2 flex-column gap-4 md:flex">
      <app-aside-public class="pt-2"/>
  </div>
</div>

<app-mensajes-emergentes/>
